import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import ResalesRequestService from '../../services/resales-request';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';

const ResalesList = () => {

  //const [quoteRequest, setQuoteRequest] = useState([]);
  const defaultFilters = { search: '', per_page: 10, page: 1, elite: '' };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({data:[]});
  const [info, setInfo] = useState({segment:[],client_type:[],status:[],bu:[],load:true});

  const [pageReturn, setPageReturn] = useState('./resales/show');
  const Data = [];
  let detailsArray = [];

  useEffect(() => {
    if(localStorage.getItem('returnPage')!=null){
      setPageReturn(localStorage.getItem('returnPage'));
      localStorage.removeItem('returnPage');
    }
    if(info.load == true){
      let info = ResalesRequestService.getInfoResale();
      info.then(data => {
        setInfo(data.data);
      });
    }
    let companies = ResalesRequestService.getAll({ params: { ...filters } });
    companies
      .then(data => {
        setReports(data.data);
      });
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const renderData = () => {
    var ids = [];
    let model = {id:0,count:0}
    Object.values(reports.data).map((company, k) => {
      var m = null;
      ids = ids.map(a=>{
        if(a.id == company.id){
          a.count+=1;
          m = a;
        }
        return a
      })
      if(m==null){
        m = {...model};
        m.id = company.id;
        m.count = 1;
        ids.push(m);
      }
      var id = m.id+'-'+m.count;
      Data.push({
        id: id,
        btn:btn(company.id,company.name),
        name: company.name,
        document: company.document,
        premium: company.premium==1?(company.vip==1?'Elite VIP':'Elite'):'Não Elite',
        bu:company.bu_principal?company.bu_principal:'---',
        client_type_id:company.client_type_name,
        segment_id:company.segment_name,
        sumo_status:company.sumo_status==1?'Ativo':'Inativo',
        value:company.value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }),
      });
    });
  }

  const columns = [
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'document',
      text: 'CNPJ',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'premium',
      text: 'Classificação',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'bu',
      text: 'BU',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'client_type_id',
      text: 'Tipo de Cliente',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'segment_id',
      text: 'Segmento',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'sumo_status',
      text: 'Status',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'value',
      text: 'Fat Total',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  function btn(id,name,alias) {
    var btn_id = "btn-" + id;
    return (
    <Button variant="primary" className="font-12" type="button" id={btn_id} onClick={()=>{
      localStorage.setItem("companyId", id);
      localStorage.setItem("companyName", name);
      localStorage.setItem("companyAlias", alias);
      
      window.location.href = pageReturn;
    }}>
      Acessar
    </Button>);
  }
  renderData();

  function download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=Windows-1252,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
  
    element.style.display = 'none';
    document.body.appendChild(element);
  
    element.click();
  
    document.body.removeChild(element);
  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col xs={6} className="align-self-center">
                    <h4 className={styles.headerTitle}>
                      Revendas
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={styles.line} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Pesquisa:</Form.Label>
                      <Form.Control
                        as="input"
                        //value={filters.per_page}
                        onChange={e => handleFilterChange({ search: e.target.value })}
                      >
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Classificação:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.elite}
                        onChange={e =>
                          handleFilterChange({ elite: e.target.value })
                        }
                      ><option value="">Todos</option>
                      <option value={0}>Não Elite</option>
                      <option value={1}>Elite</option>
                      <option value={2}>Elite Vip</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>BU:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.bu}
                        onChange={e =>
                          handleFilterChange({ bu: e.target.value })
                        }
                      >
                      <option value="">Todos</option>
                      {info.bu.map((bu, key)=>{
                        return(
                        <option value={bu.id} key={key}>{bu.name}</option>
                        );
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Tipo de cliente:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.client_type}
                        onChange={e =>
                          handleFilterChange({ client_type: e.target.value })
                        }
                      ><option value="">Todos</option>
                      {Object.values(info.client_type).map((v,key)=>{
                        return (<option value={v.id} key={key}>{v.name}</option>)
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Segmento:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.segment}
                        onChange={e =>
                          handleFilterChange({ segment: e.target.value })
                        }
                      ><option value="">Todos</option>
                      {Object.values(info.segment).map((v,key)=>{
                        return (<option value={v.id} key={key}>{v.name}</option>)
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={2}>
                    <Form.Group>
                      <Form.Label>Status:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.status}
                        onChange={e =>
                          handleFilterChange({ status: e.target.value })
                        }
                      >
                        <option value="">Todos</option>
                        {Object.values(info.status).map((v,key)=>{
                        return (<option value={v.id} key={key}>{v.name}</option>)
                      })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}>
                    <Form.Group>
                      <Form.Label>Registros por página:</Form.Label>
                      <Form.Control
                        as="select"
                        value={filters.per_page}
                        onChange={e =>
                          handleFilterChange({ per_page: e.target.value })
                        }
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  {/* <Col className="d-flex justify-content-end">
                    <Form.Group>
                      <Button variant="dark"
                        style={{marginTop:'calc(50% - 19px)'}}
                        onClick={()=>{
                          let companies = ResalesRequestService.getAllExport({ params: { ...filters } });
                          companies
                            .then(data => {
                          });
                        }}>
                        Exportar
                      </Button>
                    </Form.Group>
                  </Col> */}
                </Row>
                <BootstrapTable
                  id="table"
                  className="font-10"
                  keyField="id"
                  data={Data}
                  columns={columns}
                  //expandRow={expandRow}
                />
                <Row>
                  <Col>
                    <Trans i18nKey="label:interpolateShowingRecords">
                      Showing {{ from: reports.from || '0' }} to{' '}
                      {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                      records
                    </Trans>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Pagination
                      activePage={reports.current_page}
                      itemsCountPerPage={reports.per_page}
                      totalItemsCount={reports.total}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                      prevPageText="‹"
                      nextPageText="›"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MasterPage(ResalesList);